module.exports = __webpack_public_path__ + "img/intro_login_1.2a4812df.png";